import * as Yup from "yup";

// ─── Enums ────────────────────────────────────────────────────────────────────
// Single source of truth — import these wherever you need the lists.

export const COST_SERVICE_TYPES = [
  "HOUR",
  "PIECE",
  "LIFT",
  "KM",
  "FLAT",
  "QTY",
  "MATRIX",
] as const;
export const TAX_OPTIONS = ["0", "24", "NO_TAX"] as const;

export type CostServiceType = (typeof COST_SERVICE_TYPES)[number];
export type TaxType = (typeof TAX_OPTIONS)[number];

// ─── Cost Service Form Schema ─────────────────────────────────────────────────
// Validates ONLY the fields registered in react-hook-form.
//
// Matrix fields (zones, bands, priceMatrix) live in local component state
// and are validated separately via validateMatrix() before submission.

export const createCostServiceSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required("validation:service.codeRequired")
    .min(2, "validation:service.codeMin")
    .max(30, "validation:service.codeMax"),

  description: Yup.string()
    .trim()
    .max(1000, "validation:service.descMax")
    .nullable()
    .optional(),

  type: Yup.string()
    .oneOf([...COST_SERVICE_TYPES], "validation:service.typeInvalid")
    .required("validation:service.typeRequired"),

  tax: Yup.string()
    .oneOf([...TAX_OPTIONS], "validation:service.taxInvalid")
    .required("validation:service.taxRequired"),

  partnerId: Yup.string().nullable().optional(),

  // Price: required and must match format only when type is NOT MATRIX.
  price: Yup.string().when("type", {
    is: "MATRIX",
    then: (s) => s.optional().nullable(),
    otherwise: (s) =>
      s
        .required("validation:service.priceFieldRequired")
        .test(
          "price-format",
          "validation:service.priceFormat",
          (v) => !!v && /^\d{1,5}(\.\d{1,2})?$/.test(v),
        ),
  }),
});
